import { RouteObject } from "react-router";

export const NodeDiagramRoutes: RouteObject = {
	path: "nodediagram/*",
	errorElement: () => <div>Procedure diagram not found</div>,

	children: [],
};
